import React from 'react';
import classnames from 'classnames';
import {
  Card, CardBody, CardHeader,
} from 'reactstrap';

import { Intl } from 'components';

export default React.memo( ( {
  children, title, titleRightContent, isLoading, translateTitle = true,
} ) => (
  <Card
    className={classnames( 'card-app-default', { 'app-component-loading': isLoading } )}
  >
    {title
      ? (
        <CardHeader className="py-2 d-flex justify-content-between">
          <h3 className="title font-weight-normal d-inline-block mb-0 mr-md-3 text-uppercase">
            {translateTitle ? <Intl id={title} /> : title}
          </h3>
          {titleRightContent}
        </CardHeader>
      ) : null}

    <CardBody>
      {children}
    </CardBody>
  </Card>
) );
